module.exports = __webpack_public_path__ + "static/media/apply-cover-Mobile.ae240e56.png";